import * as React from 'react';
import { SVGProps } from 'react';

const IconArrowRedoneSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.172 6 8.586 4.414 10 3l4 4-4 4-1.414-1.414L10.172 8H5.5a1.5 1.5 0 1 0 0 3H6v2h-.5a3.5 3.5 0 1 1 0-7h4.672Z"
    />
  </svg>
);
export default IconArrowRedoneSizeS;
